import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { Toaster, LoadingSpinner } from "@guardian/shared-ui";
import { AppRoutes } from "./routes";
import { ThemeProvider } from "@/components/theme-provider";
import { MotionConfig } from "framer-motion";
import * as Sentry from "@sentry/react";
import "@/styles/react-datepicker-overrides.css";


function AppContent() {
  return (
    <Suspense
      fallback={
        <div className="flex h-dvh w-full items-center justify-center">
          <LoadingSpinner />
        </div>
      }
    >
      <AppRoutes />
      <Toaster />
    </Suspense>
  );
}

// Create Sentry-instrumented BrowserRouter
const SentryBrowserRouter = Sentry.withSentryReactRouterV7Routing(BrowserRouter);

export default function App() {
  return (
    <SentryBrowserRouter>
      <ThemeProvider defaultTheme="system" storageKey="guardian-form-theme">
        <MotionConfig reducedMotion="user">
          <AppContent />
        </MotionConfig>
      </ThemeProvider>
    </SentryBrowserRouter>
  );
}
